<template>
  <div>
    <form role="form" @submit.stop.prevent="emitForm">
      <div class="vx-row">
        <div class="vx-col sm:w-1/1 w-full mb-2">
          <label for="" class="vs-select--label">Tipo de Boleto</label>
          <v-select
            :options="tiposBoletos"
            name="Tipo de Boleto"
            id="Tipo de Boleto"
            v-model="form.idTipoBoleto"
            :reduce="(item) => item.idTipoBoleto"
            v-validate="{ required: true }"
            label="label"
            @input="atualizaConsidereadoFechamento()"
            :state="validateState('Tipo de Boleto')"
            :class="validateClass('Tipo de Boleto')"
          >
          </v-select>
        </div>

        <div
          class="vx-col sm:flex block gap-5 mb-2 mt-2"
          v-if="form.idTipoBoleto == 1"
        >
          <span>Considerar Fechamento?</span>
          <vs-switch
            color="success"
            v-model="form.considerarFechamento"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
        <div class="vx-col w-full mb-2">
          <label for="" class="vs-input--label">Descrição</label>
          <vs-input
            class="w-full"
            name="Descrição"
            id="Descrição"
            placeholder="Referente à"
            v-model="form.descricao"
            :state="validateState('Descrição')"
            :danger="validateClass('Descrição')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
        </div>

        <div class="vx-col sm:w-1/1 w-full mb-2">
          <label for="" class="vs-select--label">Veículo</label>
          <v-select
            :options="veiculosForm"
            name="Veículo"
            id="Veículo"
            v-model="form.idVeiculo"
            :reduce="(item) => item.id_veiculo"
            v-validate="{ required: true }"
            label="placa"
            multiple
            @input="selecionaVeiculo()"
            :state="validateState('Veículo')"
            :class="validateClass('Veículo')"
          >
          </v-select>
        </div>
        <div
          v-if="visualizaValoresProdutos"
          class="vx-col sm:w-1/1 w-full mb-15"
        >
          <div
            class="relative overflow-x-auto shadow-md sm:rounded-lg mb-5"
            v-for="veiculo in produtosPorVeiculos"
            :key="veiculo.id_veiculo"
          >
            <div class="mx-5 mt-4 mb-2 flex">
              <div class="flex-1">
                <vs-chip class="text-gray-500 rounded" color="#078fcf">
                  {{ veiculo.placa }}
                </vs-chip>
                <span class="mt-2 ml-2">
                  {{ veiculo.veiculoModelo }} - {{ veiculo.Status }} | Dia de
                  vencimento
                  {{ veiculo.diaVencimento }}
                </span>
              </div>
              <div @click="changeVisualizacaoVeiculo(veiculo)">
                <vs-chip class="cursor-pointer">
                  <vs-icon
                    icon-pack="feather"
                    :icon="veiculo.show ? 'icon-minimize-2' : 'icon-maximize-2'"
                    color="gray"
                    size="small "
                  ></vs-icon>
                </vs-chip>
              </div>
            </div>
            <transition name="fade">
              <table
                v-if="veiculo.show"
                class="w-full text-sm text-left text-gray-500 dark:text-gray-400"
              >
                <thead
                  class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
                >
                  <tr>
                    <th scope="col" class="p-4"></th>
                    <th scope="col" class="px-6 py-3">Produto</th>
                    <th scope="col" class="px-6 py-3">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="produto in veiculo.produtos"
                    :key="produto.id_veiculo_produto"
                    class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                  >
                    <td class="w-4 p-4">
                      <div class="flex items-center">
                        <input
                          id="checkbox-table-search-1"
                          type="checkbox"
                          v-model="produto.checkbox"
                          @change="
                            (form.valor = changeValorTotal()),
                              changeValorTotalPorVeiculo()
                          "
                          :disabled="
                            !$can(
                              'Editar Valores Do Produto No Boleto',
                              'Associados',
                            )
                          "
                          class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                        <label for="checkbox-table-search-1" class="sr-only"
                          >Selecionar Produto</label
                        >
                      </div>
                    </td>
                    <th
                      scope="row"
                      class="py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      <div class="flex items-center">
                        <vs-chip
                          class="text-gray-500 rounded"
                          color="#e4a300"
                          size="x-small"
                          v-if="produto.isMensal"
                        >
                          Mensal
                        </vs-chip>
                        <span>
                          {{
                            produto.descricao_produto_sga || produto.nomeProduto
                          }}
                        </span>
                      </div>
                    </th>
                    <td class="px-6 py-4 flex">
                      <money
                        class="w-full vs-inputx vs-input--input normal"
                        name="Valor"
                        id="Valor"
                        :disabled="disableEditValues(produto)"
                        v-model="produto.valor"
                        v-bind="money"
                      ></money>
                    </td>
                  </tr>
                </tbody>
              </table>
            </transition>
            <footer class="bg-white rounded-lg shadow m-4 dark:bg-gray-800">
              <div
                class="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-start md:justify-between md:flex-col"
              >
                <span
                  class="text-sm text-gray-500 sm:text-center dark:text-gray-400"
                  ><strong
                    >Valor Mensal: {{ veiculo.valorTotal | currency }}</strong
                  >
                </span>
                <span
                  class="text-sm text-gray-500 sm:text-center dark:text-gray-400"
                  v-if="veiculo.comissao > 0"
                  ><strong
                    >Valor Comissionamento:
                    {{
                      calcularComissionamento(
                        veiculo.valorTotal,
                        veiculo.comissao,
                      ) | currency
                    }}</strong
                  >
                </span>
                <span
                  class="text-sm text-gray-500 sm:text-center dark:text-gray-400"
                  v-if="veiculo.comissao > 0"
                  ><strong
                    >Valor Total para veiculo:
                    {{
                      calcularValorTotalComComissao(
                        veiculo.valorTotal,
                        veiculo.comissao,
                      ) | currency
                    }}</strong
                  >
                </span>
              </div>
            </footer>
          </div>
        </div>

        <div v-else class="vx-col sm:w-1/1 w-full mb-2">
          <label for="" class="vs-select--label">Produtos Vinculados</label>
          <v-select
            :options="produtosAux"
            name="Produtos Vinculados"
            id="Produtos Vinculados"
            v-model="form.idProduto"
            multiple
            :reduce="(item) => item.id_produto || item.idProduto"
            :get-option-label="getLabel"
            :state="validateState('Produtos Vinculados')"
            :class="validateClass('Produtos Vinculados')"
          >
          </v-select>
        </div>

        <div class="mx-4 mt-5 sm:flex sm:justify-between w-full gap-4">
          <div class="sm:w-1/3 w-full">
            <label for="Mês Referencia" class="vs-input--label"
              >Mês Referencia</label
            >
            <datepicker
              :minimumView="'month'"
              :maximumView="'year'"
              label-placeholder="Mês Referencia"
              name="Mês Referencia"
              id="Mês Referencia"
              input-class="inputData w-full large"
              :format="'MM/yyyy'"
              label="MM/YYYY"
              :language="languages['ptBR']"
              v-model="form.mesReferente"
              v-validate="{ required: true }"
              :state="validateState('Mês Referencia')"
              :class="validateClass('Mês Referencia')"
            ></datepicker>
          </div>

          <div class="sm:w-1/3 w-full">
            <label for="Data de Vencimento" class="vs-input--label"
              >Data de Vencimento</label
            >
            <datepicker
              input-class="inputData w-full large"
              :format="'dd/MM/yyyy'"
              label="DD/MM/YYYY"
              v-model="form.dataVencimento"
              v-validate="{
                required: true,
                min: 10,
                date_format: 'dd/MM/yyyy',
              }"
              :monday-first="true"
              :auto-placement="true"
              :language="languages['ptBR']"
              name="Data de Vencimento"
              :state="validateState('Data de Vencimento')"
              :danger="validateClass('Data de Vencimento')"
            ></datepicker>
          </div>

          <div class="sm:w-1/3 w-full">
            <label for="" class="vs-input--label">Valor</label>
            <money
              class="w-full vs-inputx vs-input--input normal"
              name="Valor"
              id="Valor"
              :disabled="visualizaValoresProdutos"
              v-model="form.valor"
              v-validate="{ required: true, min_value: 0.01 }"
              :state="validateState('Valor')"
              :danger="validateClass('Valor')"
              v-bind="money"
            ></money>
          </div>
        </div>

        <div class="vx-col sm:w-1/1 w-full mb-2">
          <label for="" class="vs-select--label">Carteira de Cobrança</label>
          <v-select
            :options="carteirasCobranca"
            name="Carteira de Cobrança"
            id="Carteira de Cobrança"
            v-model="form.idCarteira"
            :reduce="(item) => item.idCarteira"
            v-validate="{ required: true }"
            label="nomeCarteira"
            @input="selecionaCarteiraCobranca()"
            :state="validateState('Carteira de Cobrança')"
            :class="validateClass('Carteira de Cobrança')"
          >
          </v-select>
        </div>

        <div
          v-if="formasPagamento.length > 0"
          class="vx-col sm:w-1/1 w-full mb-2"
        >
          <label for="" class="vs-select--label">Forma de Pagamento</label>
          <v-select
            :options="formasPagamento"
            name="Forma de Pagamento"
            id="Forma de Pagamento"
            v-model="form.idTipoPagamentoEmpresa"
            v-validate="{ required: true }"
            label="nomePagamento"
            :state="validateState('Forma de Pagamento')"
            :class="validateClass('Forma de Pagamento')"
          >
          </v-select>
        </div>

        <div class="vx-col w-full mb-2">
          <label for="" class="vs-input--label">Observação</label>
          <vs-textarea
            class="w-full"
            name="Observação"
            id="Observação"
            v-model="form.observacao"
            :state="validateState('Observação')"
            :danger="validateClass('Observação')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-alert
            v-if="$validator.errors.all().length > 0"
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            <ul>
              <li
                class="mb-2"
                v-for="error in $validator.errors.all()"
                :key="error.id"
              >
                {{ error }}
              </li>
            </ul>
          </vs-alert>
        </div>
        <div class="vx-col w-full text-right">
          <BotaoSubmit
            variant="success"
            :edit="false"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import service from './../../services';
import locale from './../../locale';
import { Money } from 'v-money';
import BotaoSubmit from '../../components/BotaoSubmit';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';

import * as lang from 'vuejs-datepicker/src/locale';
import { decryptData } from './../../services/decryptData';
import {
  TIPO_PAGAMENTO,
  TIPO_PAGAMENTO_NOME,
} from '@/commons/constant/tipo-pagamento';
import { TIPO_BOLETO } from '@/commons/constant/tipo-boleto';

export default {
  props: ['idAssociado', 'veiculos', 'contadorRenderAvulso', 'placas'],
  watch: {
    idAssociado() {
      this.preencheForm();
    },
    contadorRenderAvulso() {},
    produtosPorVeiculos: {
      handler(newArray, oldArray) {
        this.changeValorTotalPorVeiculo();
        this.form.valor = this.changeValorTotal();
      },
      deep: true,
    },
    form: {
      handler(newArray, oldArray) {
        // checa form.idVeiculo e veiculosForm === all
        if (this.form.idVeiculo.length > 0) {
          if (this.form.idVeiculo.find((item) => item == 'all')) {
            this.form.idVeiculo = [];
            this.form.idVeiculo = this.veiculosForm
              .filter((item) => item.id_veiculo !== 'all')
              .map((item) => item.id_veiculo);
          }
        }
        // carregando produtosPorVeiculos sem clonar variavel veiculos
        let veiculos = JSON.parse(
          JSON.stringify(
            this.placas.filter((x) =>
              this.form.idVeiculo.includes(x.id_veiculo),
            ),
          ),
        );

        const veiculosOldIds = [...new Set(this.produtosPorVeiculos)].map(
          (item) => item.id_veiculo,
        );

        veiculos = veiculos.map((veiculo) => {
          // caso item ja estege carregado manter dqados
          if (veiculosOldIds.includes(veiculo.id_veiculo)) {
            veiculo = this.produtosPorVeiculos.find(
              (item) => item.id_veiculo == veiculo.id_veiculo,
            );
          }

          // Regra de produtos que serao puxados
          veiculo.produtos = veiculo.produtos.filter(
            (produto) => produto.situacao == 'ATIVO' && produto.isMensal,
          );
          // inicia a visualizacao expandida do card com produtos
          if (Object.keys(veiculo).includes('show') == false) {
            veiculo.show = true;
          }

          veiculo.produtos = veiculo.produtos.map((produto) => {
            // inicia o checkbox como true de cada produto para somar valor total
            if (Object.keys(produto).includes('checkbox') == false) {
              produto.checkbox = true;
            }
            // Transforma o valor em float com duas casas decimais (financeiro)
            produto.valor = parseFloat(produto.valor).toFixed(2);
            return produto;
          });
          return veiculo;
        });

        this.produtosPorVeiculos = veiculos;
      },
      deep: true,
    },
    'form.idTipoPagamentoEmpresa'() {
      const isPrimeiraParcela =
        this.form.idTipoBoleto === TIPO_BOLETO.PRIMEIRA_PARCELA;
      const isPagamentoCartaoCredito =
        this.form.idTipoPagamentoEmpresa.id_tipoPagamento ===
          TIPO_PAGAMENTO.CARTAO_CREDITO ||
        this.form.idTipoPagamentoEmpresa.nomePagamento ===
          TIPO_PAGAMENTO_NOME.CARTAO_CREDITO;
      if (!isPrimeiraParcela && isPagamentoCartaoCredito) {
        this.$validator.errors.add({
          field: 'tipo_pagamento_cartao_credito',
          msg: 'Para o tipo de pagamento Cartão de Crédito, é necessário que a cobrança seja de Primeira Parcela.',
        });
        this.form.idTipoPagamentoEmpresa = null;
        return;
      }

      this.$validator.errors.remove('tipo_pagamento_cartao_credito');

      if (isPagamentoCartaoCredito) {
        if (this.form.idVeiculo.length > 1) {
          this.$validator.errors.add({
            field: 'veiculo_cartao_credito',
            msg: 'Para o tipo de pagamento Cartão de Crédito, é necessário selecionar apenas um veículo.',
          });
          this.form.idVeiculo = [];
        }
        return;
      }
      this.$validator.errors.remove('veiculo_cartao_credito');
    },
    'form.idVeiculo'() {
      const isPrimeiraParcela =
        this.form.idTipoBoleto === TIPO_BOLETO.PRIMEIRA_PARCELA;

      const isPagamentoCartaoCredito =
        this.form.idTipoPagamentoEmpresa.id_tipoPagamento ===
          TIPO_PAGAMENTO.CARTAO_CREDITO ||
        this.form.idTipoPagamentoEmpresa.nomePagamento ===
          TIPO_PAGAMENTO_NOME.CARTAO_CREDITO;

      if (!isPrimeiraParcela && isPagamentoCartaoCredito) {
        this.$validator.errors.add({
          field: 'tipo_pagamento_cartao_credito',
          msg: 'Para o tipo de pagamento Cartão de Crédito, é necessário que a cobrança seja de Primeira Parcela.',
        });
        this.form.idTipoPagamentoEmpresa = null;
        return;
      }

      this.$validator.errors.remove('tipo_pagamento_cartao_credito');

      if (
        this.form.idVeiculo.length > 1 &&
        isPagamentoCartaoCredito &&
        isPrimeiraParcela
      ) {
        this.$validator.errors.add({
          field: 'veiculo_cartao_credito',
          msg: 'Para o tipo de pagamento Cartão de Crédito, é necessário selecionar apenas um veículo.',
        });
        this.form.idVeiculo = [];
        return;
      }

      this.$validator.errors.remove('veiculo_cartao_credito');
    },
  },
  components: { Money, BotaoSubmit, vSelect, Datepicker },
  data() {
    return {
      language: 'br',
      languages: lang,
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$',
        suffix: '',
        precision: 2,
      },
      aguardeCadastro: false,
      status: ['ATIVO', 'INATIVO', 'PENDENTE'],
      produtosAux: [],
      idProduto: [],
      carteirasCobranca: [],
      formasPagamento: [],
      tiposBoletos: [],
      form: {
        idAssociado: null,
        idVeiculo: [],
        idProduto: [],
        idCarteira: null,
        idTipoBoleto: null,
        valor: null,
        idTipoPagamentoEmpresa: null,
        isGalax: null,
        mesReferente: null,
        considerarFechamento: null,
      },
      veiculosForm: [],
      produtosPorVeiculos: [],
      listLicencePlates: [],
    };
  },
  computed: {
    visualizaValoresProdutos() {
      return (
        this.produtosPorVeiculos.length > 0 &&
        [1, 2].includes(this.form.idTipoBoleto)
      );
    },
  },
  methods: {
    getLabel(item) {
      return item.descricao_produto_sga || item.nomeProduto;
    },
    disableEditValues(produto) {
      if (!this.$can('Editar Valores Do Produto No Boleto', 'Associados'))
        return true;

      if (!produto.checkbox) return true;

      return false;
    },
    changeValorTotal() {
      if (!this.visualizaValoresProdutos) {
        return this.form.valor;
      }

      return this.produtosPorVeiculos.reduce((acc, veiculo) => {
        const valorTotalVeiculo = veiculo.produtos.reduce(
          (produtoAcc, produto) => {
            return produto.checkbox
              ? produtoAcc + parseFloat(produto.valor || 0)
              : produtoAcc;
          },
          0,
        );

        const comissionamento = veiculo.comissao
          ? (valorTotalVeiculo * veiculo.comissao) / 100
          : 0;

        return acc + valorTotalVeiculo + comissionamento;
      }, 0);
    },
    changeValorTotalPorVeiculo() {
      if (this.produtosPorVeiculos.length > 0) {
        this.produtosPorVeiculos.forEach((veiculo) => {
          veiculo.valorTotal = veiculo.produtos.reduce((acc, produto) => {
            if (produto.checkbox) {
              acc += parseFloat(produto.valor);
            }
            return acc;
          }, 0);
        });
      }
    },
    changeVisualizacaoVeiculo(payload) {
      this.produtosPorVeiculos.forEach((veiculo) => {
        if (veiculo.id_veiculo == payload.id_veiculo) {
          veiculo.show = !payload.show;
        }
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    selecionaVeiculo() {
      if (this.form.idTipoBoleto != 2) {
        var aux = this.placas.find(
          (x) => x.id_veiculo == this.form.idVeiculo[0],
        );

        this.produtosAux = aux.produtos.filter((x) => x.situacao == 'ATIVO');
      }
    },
    selecionaCarteiraCobranca() {
      var aux = this.carteirasCobranca.find(
        (x) => x.idCarteira == this.form.idCarteira,
      );

      this.form.isGalax = aux.isGalaxyPay;
      this.buscaFormasPagamentoDisponiveis();
    },
    preencheForm() {
      this.form.idAssociado = this.idAssociado;
    },
    buscaFormasPagamentoDisponiveis() {
      this.$vs.loading();
      service
        .post('CarteiraCobranca', 'buscaFormasPagamentoDisponiveis', this.form)
        .then((res) => {
          this.formasPagamento = res.data.filter((x) => x.selecionado == 1);
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    emitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          // pegando ids de produtos se for boleto diferente de avulso
          if (this.visualizaValoresProdutos)
            this.form.idProduto = Array.from(
              new Set(
                this.produtosPorVeiculos.reduce((accPV, item) => {
                  accPV.push(
                    ...item.produtos.reduce((acc, item) => {
                      acc.push(item.id_produto);
                      return acc;
                    }, []),
                  );
                  return accPV;
                }, []),
              ),
            );
          service
            .post('Financeiro', 'cadastrarCobrancaAvulsa', this.form)
            .then(() => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Cobrança Cadastrada com Sucesso',
                color: 'success',
              });
              this.$emit('finished', {});
              this.$vs.loading.close();
            })
            .catch((e) => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: e,
                color: 'danger',
              });
              this.$vs.loading.close();
            });
        } else {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Existem campos não preenchidos',
            color: 'danger',
          });
        }
      });
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll(
          'g',
          {},
          `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}?deletedAt=null`,
        )
        .then(({ data }) => {
          data = decryptData(data);
          data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaTiposBoletos() {
      service.getAll('boletos', {}, `buscar-tipos-boletos`).then(({ data }) => {
        data.forEach((element) => {
          element.id = element.idTipoBoleto;
          element.label =
            element.tipoBoleto === 'Adesão'
              ? 'Contratação'
              : element.tipoBoleto;
          this.tiposBoletos.push(element);
        });
      });
    },
    ajustaObjVeiculos() {
      return [
        {
          id_veiculo: 'all',
          placa: 'Selecionar Todas',
        },

        ...this.placas.reduce((acc, veiculo) => {
          const {
            id_veiculo,
            placa,
            chassi,
            veiculoModelo,
            veiculoMarca,
            status,
            produtos,
            comissao,
          } = veiculo;

          const dadosVeiculo = {
            produtos,
            id_veiculo,
            placa: `${placa || chassi} - ${
              veiculoModelo || veiculoMarca
            } - ${status}`,
            comissao,
          };

          acc.push(dadosVeiculo);
          return acc;
        }, []),
      ];
    },
    // ajustaObjVeiculos() {
    //   const transformedVehicles = [
    //     {
    //       id_veiculo: 'all',
    //       placa: 'Selecionar Todas',
    //     },
    //     ...this.placas.reduce((acc, veiculo) => {
    //       const {
    //         id_veiculo,
    //         placa,
    //         chassi,
    //         veiculoModelo,
    //         veiculoMarca,
    //         status,
    //         produtos,
    //       } = veiculo;

    //       const placaDescription = [
    //         placa || chassi,
    //         veiculoModelo || veiculoMarca,
    //         status,
    //       ]
    //         .filter(Boolean)
    //         .join(' - ');

    //       const dadosVeiculo = {
    //         produtos,
    //         id_veiculo,
    //         placa: placaDescription,
    //       };

    //       acc.push(dadosVeiculo);
    //       return acc;
    //     }, []),
    //   ];
    //   this.$forceUpdate();
    //   return transformedVehicles;
    // },

    listOfLicencePlates() {
      const licenceOfPlates = this.placas.map(
        ({ placa, chassi, veiculoModelo, veiculoMarca, status }) => ({
          placa: `${placa} - ${chassi} - ${veiculoModelo} - ${veiculoMarca} - ${status}`,
        }),
      );

      return licenceOfPlates;
    },
    atualizaConsidereadoFechamento() {
      if (this.form.idTipoBoleto == 1) {
        this.form.considerarFechamento = true;
      } else {
        this.form.considerarFechamento = null;
      }
    },
    calcularComissionamento(valorTotal, comissao) {
      const isComissaoValida = comissao && !isNaN(comissao);
      if (isComissaoValida) {
        return (valorTotal * comissao) / 100;
      }
      return 0;
    },
    calcularValorTotalComComissao(valorTotal, comissao) {
      const comissionamento = this.calcularComissionamento(
        valorTotal,
        comissao,
      );
      return valorTotal + comissionamento;
    },
  },
  mounted() {
    this.preencheForm();
    this.$validator.localize('ptBr', locale);
    this.buscaTiposBoletos();
    this.buscaDadosSelectsPorEmpresa(
      'empresasCarteiraCobranca',
      'carteirasCobranca',
      'nomeCarteira',
      'idCarteira',
    );
    this.listLicencePlates = this.listOfLicencePlates();
    this.veiculosForm = this.ajustaObjVeiculos();
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vs-con-textarea {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
